import React from 'react';
import { Col, ListGroup } from 'reactstrap';
 
import DependsOnQuestionsListItem from './DependsOnQuestionsListItem';
import DependsOnAnswersList from './DependsOnAnswersList';

const DependsOnQuestionsList = props => {

    if (props.answers === undefined || props.answers === null
        || props.dependsOnQuestions === undefined || props.dependsOnQuestions === null) return <div />;

    const { scrollableAnswerGroup, fullWidthStyle } = styles;

    return (
        <Col xs={12} sm={4} style={scrollableAnswerGroup}>
            <ListGroup style={fullWidthStyle}>
                {
                    props.dependsOnQuestions.map((dependsOnQuestion, i) => {

                        return (
                            <div key={`dependsOnQs_${i}`}>
                                <DependsOnQuestionsListItem {...props} dependsOnQuestion={dependsOnQuestion} iterator={i} />
                                <DependsOnAnswersList {...props} dependsOnQuestion={dependsOnQuestion} iterator={i} />
                            </div>
                        );
                    })
                }
            </ListGroup>
        </Col >
    );
}

export default DependsOnQuestionsList;

const styles = {
    scrollableAnswerGroup: {
        overflowY: 'auto',
        height: 420
    },
    fullWidthStyle: {
        width: '100%'
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/dependsOn/DependsOnQuestionsList.js